import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"snack"}},[(_vm.active)?_c(VSnackbar,{attrs:{"id":"snack","bottom":"","right":"","color":_vm.snack.color || 'success',"timeout":_vm.snack.timeout || 3000},on:{"input":_vm.close,"click":_vm.close},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_vm._v(" "+_vm._s(_vm.snack.text || 'Hooray')+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }